var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'd-flex align-center primary--text text-h5 text-md-h4 text-lg-h3 font-weight-bold',
    _vm.className ]},[_c('img',{staticClass:"d-block mr-3",attrs:{"src":require("../../assets/img/vinheta.png"),"height":_vm.smAndDown ? '40px' : _vm.mdOnly ? '50px' : '56px'}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }